import React from "react";
import building1 from "../../../../assets/img/admin/buildings.svg";
import house1 from "../../../../assets/img/admin/house-3.svg";
import house from "../../../../assets/img/admin/house-2.svg";
import building from "../../../../assets/img/admin/buliding.svg";
import edit from "../../../../assets/img/admin/edit.svg";
import trash from "../../../../assets/img/admin/trash-2.svg";
import Button from "../../../shared/Button";
import useFetch from "../../../../hooks/useAxios";
import toast from "react-hot-toast";
const WageTypesrow = ({ id, img, title, perc,setTypeWageEdit ,setTypeWageMessage,apiWageList}) => {
  const EditFunc = ()=>{
    setTypeWageMessage({
      residence_type:title ,
      wage_percentage:perc,
      id:id
    })

    setTypeWageEdit(true);
  }
  const delWageForAll = useFetch({
    method: "post",
    url: `api/admin/wages/delete/${id}`,
    noHeader: false,
    trigger: false,
    caller:apiWageList,
    argFunc:res=>{
        toast.success("کارمزد پاک شد.")
    },
    errMessage:err=>{
        toast.error(err.message)
    }
  });

  const deletefunc=()=>{
    delWageForAll.reFetch()
  }
  return (
    <div className="WageTypesrow flex items-center justify-between">
      <div className="flex items-center  gap-[20px]">
        <div className={`WageTypesrow-card-${id} h-[64px] w-[64px]   center`}>
          <img src={img} />
        </div>
        <h3 className="text-[24px] text-[#12171C] ">
          {title}
        </h3>
      </div>
      <div className="flex gap-[24px] items-center">
        <button  onClick={deletefunc}>
          <img src={trash} />
        </button>
        <button onClick={EditFunc}>
          <img src={edit} />
        </button>
        <Button varient="primary">
          {perc}% کارمزد
        </Button>
      </div>
    </div>
  );
};
const WageTypes = ({ WageList,setTypeWageMessage,setTypeWageEdit,apiWageList }) => {
  return (
    <div>
      <h4 className="text-[36px] text-[#12171C] font-[700] my-[36px] ">
        انواع اقامتگاه ها
      </h4>

      <div className="WageTypes">
        {WageList.by_type.map(i =>
          <div>
            <WageTypesrow
              perc={i.wage_percentage}
              img={house}
              id={i.id}
              title={i.type}
              setTypeWageMessage={setTypeWageMessage}
              setTypeWageEdit={setTypeWageEdit}
              apiWageList={apiWageList}
            />{" "}
            <hr />
          </div>
        )}
      </div>
    </div>
  );
};

export default WageTypes;
